import React from 'react';

export const SortContext = React.createContext();